import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { TransactionLog, TransactionLog_SubTransaction } from '../models/TransactionLog';
import { longDateFormat } from '../../shared/StringHelper';
import { getStatusIconClassName, getStatusTextClassName, TransactionStatus } from '../models/TransactionStatus';
import { ModalService } from '../../shared/modal.service';
import { TransactionLogDetailMoreComponent } from '../transaction-log-detail-more/transaction-log-detail-more.component';
import { TransactionLogResolveConfirmationDialogComponent } from '../transaction-log-resolve-confirmation-dialog/transaction-log-resolve-confirmation-dialog.component';
import { firstValueFrom } from 'rxjs';
import { SecurityService } from '../../shared/security.service';

@Component({
    selector: 're-provisioning-errors-detail',
    templateUrl: './transaction-log-detail.component.html',
    styleUrls: ['./transaction-log-detail.component.scss'],
    standalone: false
})
export class TransactionLogDetailComponent implements OnInit {

  constructor(private modal: ModalService, private securityService: SecurityService) { }

  isSupportUser = false;
  async ngOnInit() {

    this.isSupportUser = await firstValueFrom(this.securityService.isSupportUser());
  }

  _transactionLog: TransactionLog;
  @Input()
  public set transactionLog(value: TransactionLog) {
    this._transactionLog = value;
    this._transactionLog.subTransactions.forEach(x => {
      var description :string= x.statusDescription;
      x.truncateErrorDescription = "";
      if (x.productName.toUpperCase() == "OKTA") {
        x.productName = "IDM";
      }
      //Because its giving a success json, it was not showing in Txn log
      //so have to hardcode to null so it knows it was a success.
      if (x.productName.toUpperCase() == "PP" && (x.statusCode==200 || x.statusCode==201)) {
        description = null;
      }

      if (!description)
        return;

      if (description.indexOf("{") >= 0) {
        var json = JSON.parse(description);
        description = json.message;
        if (json.errors && json.errors.length && json.errors.length > 0) {
          let errors: any[] = json.errors;


          var detailedError = "";
          errors.forEach(x => {

            if (!description.endsWith(".")){
              detailedError += "."
            }
            detailedError+= " "+x.message;
          })

          if (detailedError != "") {
            description = detailedError;
          }
        }
      }
      x.fullErrorDescription = description;
      var text = description.trim();
      if (text.length > 50) {
        text = text.substring(0, 50) + " ...";
      }
      x.truncateErrorDescription= text;
    });
  }
  public get transactionLog() {
    return this._transactionLog;
  }


  public isFailedStatus(subTransaction: TransactionLog_SubTransaction): Boolean {
    return subTransaction.statusName == TransactionStatus[ TransactionStatus.Failed ];
  }
  @Output() retried: EventEmitter<TransactionLog> = new EventEmitter();
  @Output() resolved: EventEmitter<number> = new EventEmitter();

  async resolve(subTransactionId: number) {
    let w = this.modal.create<TransactionLogResolveConfirmationDialogComponent>(TransactionLogResolveConfirmationDialogComponent);
    let result = await w.modalRef.result;
    if (result) {
      this.resolved.emit(subTransactionId);
    }
  }

  longDateFormat(date: string) {
    return longDateFormat(date);
  }


  async showMore(subTransaction: TransactionLog_SubTransaction) {
    let w = this.modal.create<TransactionLogDetailMoreComponent>(TransactionLogDetailMoreComponent);
    w.component.status = subTransaction.statusName;
    w.component.productName = subTransaction.productName;
    w.component.statusDescription = subTransaction.fullErrorDescription;
    let result = await w.modalRef.result;

  }

  getStatusIconClassName(status: string) {
    return getStatusIconClassName(status);
}

  getStatusTextClassName(status: string) {
    return getStatusTextClassName(status);
}

}
